goog.provide("shadow.js.shim.module$react_use$lib$useEvent$default");
shadow.js.shim.module$react_use$lib$useEvent$default = shadow.js.shim.module$react_use$lib$useEvent.default;
